<template>
    <div class="search-form p-2">
        <div class="col-sm-12 search-form-title">
            <font-awesome-icon icon="search" />
            {{ $t('common.search') }}
        </div>
        <form @submit.prevent="onSubmit" @reset.prevent="onReset" class="form">
            <div class="row nopads">
                <div class="col-sm-4">
                    <div class="form-group nopads">
                        <label for="status"><span class="span-title">{{ $t('orders.status') }}</span></label>
                        <select id="status" v-model="status" class="form-select form-select-sm sm-3">
                            <option :value="0">{{ $t('orders.select_status') }}</option>
                            <option :value="1">{{ $t('inspection.options.open') }}</option>
                            <option :value="2">{{ $t('inspection.options.okay') }}</option>
                            <option :value="3">{{ $t('inspection.options.defects') }}</option>
                            <option :value="4">{{ $t('inspection.options.ban') }}</option>
                        </select>
                    </div>
                </div>

                <div class="col-sm-4">
                    <div class="form-group nopads">
                        <label for="area"><span class="span-title">{{ $t('areas.area') }}</span></label>
                        <select id="area" v-model="area" class="form-select form-select-sm sm-3">
                            <option :value="-1">{{ $t('orders.select_status') }}</option>
                            <option v-for="a in areas" :key="a.id" :value="a.id">{{ a.name }}</option>
                        </select>
                    </div>
                </div>

                <div class="col-sm-4">
                    <div class="form-group nopads">
                        <label for="reporter"><span class="span-title">{{ $t('defects.reporter') }}</span></label>
                        <select id="reporter" v-model="reporter" class="form-select form-select-sm sm-3">
                            <option :value="-1">{{ $t('orders.select_status') }}</option>
                            <option v-for="r in reporters" :key="r.id" :value="r.id">{{ r.last_name }}, {{ r.first_name }}</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="row nopads">
                <div class="col-sm-4">
                    <div class="form-group nopads">
                        <label for="start"><span class="span-title">{{ $t('orders.create_time') }} - {{
                                $t('trip_list.road_sec_from')
                            }}</span></label>
                        <input id="start" v-model="fromDate" type="date" class="form-control form-control-sm" />
                    </div>
                </div>

                <div class="col-sm-4">
                    <div class="form-group nopads">
                        <label for="end"><span class="span-title">{{ $t('orders.create_time') }} - {{
                                $t('trip_list.road_sec_to')
                            }}</span></label>
                        <input id="end" v-model="toDate" type="date" class="form-control form-control-sm" />
                    </div>
                </div>
            </div>

            <div class="col-sm-12 button-container">
                <button type="submit" class="btn btn-primary form-button btn-sm">
                    {{ $t('ins_report.search') }}
                </button>
                <button type="reset" class="btn btn-danger form-button btn-sm">
                    {{ $t('ins_report.clear') }}
                </button>
            </div>
        </form>
    </div>
</template>


<script>
import {restApi} from '../../mixins/RestApiMixin'
import {timeUtils} from '../../mixins/TimeUtils'

export default {
    name: 'AreaDefectSearch',
    mixins: [restApi, timeUtils],
    data: function () {
        return {
            status: 1,
            area: -1,
            areas: [],
            fromDate: null,
            toDate: null,
            reporter: -1,
            reporters: []
        }
    },
    mounted: function () {
        this.fetchAreas()
        this.fetchReporters()
    },
    methods: {
        fetchAreas: function () {
            this.loading = true
            this.restFetch(this.areaDefectAreasUrl, this.handleAreas)
        },

        handleAreas: function (response) {
            this.loading = false
            this.areas = response.data
        },

        fetchReporters: function () {
            this.loading = true
            this.restFetch(this.areaDefectReporterUrl, this.handleReporters)
        },

        handleReporters: function (response) {
            this.loading = false
            this.reporters = response.data
        },

        onSubmit: function () {
            var params = {}
            params.status = this.status
            if (this.area > 0) {
                params.area = this.area
            }
            if (this.reporter > 0) {
                params.reporter = this.reporter
            }
            if (this.fromDate !== null && this.fromDate.trim()) {
                params.dateFrom = this.localTimeToUtcTime(this.fromDate).getTime()
            }
            if (this.toDate !== null && this.toDate.trim()) {
                params.dateTo = this.getEndOfTheDay(this.toDate).getTime()
            }
            this.$emit('search', params)
        },

        onReset: function () {
            this.status = 1
            this.area = -1
            this.reporter = -1
            this.fromDate = null
            this.toDate = null
        }
    }
}
</script>

<style scoped>

</style>
